import { returnDV0_Formatted } from "@/lib/globalFormatterHelper";
import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import React from "react";

function getValueBasedFromData(dataToUse: any, securityType: SecurityTypeCode, instrumentType: InstrumentTypeCode): number | undefined {
  const basisRiskCodes = [
    SecurityTypeCode.IBS,
    SecurityTypeCode.OBS,
    SecurityTypeCode.XBS,
  ];
  if (instrumentType == InstrumentTypeCode.FRN) {
    return dataToUse?.creditSpreadRisk;
  }

  if (basisRiskCodes.includes(securityType)) {
    return dataToUse?.basisRisk;
  }

  if (securityType == SecurityTypeCode.ZCS) {
    return dataToUse?.inflationRisk;
  }

  return dataToUse.dV01;
}

function valueBasedOnSecurityType(params: any): number | undefined {
  const dataToUse = params.data;
  const securityType = dataToUse.securityType;
  let instrumentType;
  if(dataToUse.instrumentType) {
    instrumentType = dataToUse.instrumentType;
  } else {
    instrumentType = params.colDef?.cellRendererParams?.instrumentType;
  }

  if (!securityType) {
    if (instrumentType == InstrumentTypeCode.FRN) {
      return dataToUse.creditSpreadRisk;
    }
    if (dataToUse.dV01) {
      return dataToUse.dV01;
    }

    return getValueBasedFromData(dataToUse, SecurityTypeCode.GOVT, instrumentType);
  }
  else if (dataToUse.allocations) {
    // Block Level
      const allocRiskValues = dataToUse.allocations.map((alloc: any) => getValueBasedFromData(alloc, securityType, instrumentType));
      const sumAllocRisk = allocRiskValues.reduce((accumulator: number, currentVal: number) => {
        let newVal = 0;
        let formattedVal = returnDV0_Formatted(currentVal);
        if (formattedVal.endsWith("k")) {
          formattedVal = formattedVal.substring(0, formattedVal.length - 2);
          newVal = parseFloat(formattedVal.trim()) * 1.0e3;
        } else {
          newVal = parseFloat(formattedVal);
        }
        return accumulator + newVal;
      }, 0);

      return sumAllocRisk;
  }

  return getValueBasedFromData(dataToUse, securityType, instrumentType);
}

function returnValue(valueToFormat: number | undefined) {
  if (valueToFormat) {
    return returnDV0_Formatted(valueToFormat);
  }
  return "0";
}

const RiskDV01CellRenderer = (params: any) => {
  const valueToFormat = valueBasedOnSecurityType(params);
  const riskValueToRender = returnValue(valueToFormat);

  return <div id="RiskDV01Container">{riskValueToRender}</div>;
};

export default RiskDV01CellRenderer;
